__turbopack_context__.v({
  "dropdownFooter": "LoginNav-module__Doukva__dropdownFooter",
  "header": "LoginNav-module__Doukva__header",
  "link": "LoginNav-module__Doukva__link",
  "subLink": "LoginNav-module__Doukva__subLink",
});
